import React from 'react';
import { Instagram, Facebook, Linkedin, Mail } from 'lucide-react';
const LOGO_COLOR = 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png';
export function FooterSection() {
  return <footer className="bg-[#0a0a1a] border-t border-white/5 pt-20 pb-10" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        {/* Final CTA */}
        <div className="bg-gradient-to-r from-purple-900/40 to-pink-900/40 rounded-3xl p-8 md:p-16 text-center mb-20 relative overflow-hidden" data-id="element-57">
          <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-58"></div>
          <div className="relative z-10" data-id="element-59">
            <h2 className="text-3xl md:text-4xl font-bold font-orbitron mb-6 text-white" data-id="element-60">
              ¿Listo para Despegar?
            </h2>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto text-lg" data-id="element-61">
              No dejes que tu competencia te gane. Obtén una landing page
              profesional en tiempo récord.
            </p>
            <a href="#precios" className="inline-block px-8 py-4 rounded-full bg-white text-black font-bold text-lg hover:bg-gray-200 transition-colors shadow-[0_0_20px_rgba(255,255,255,0.3)]" data-id="element-62">
              Comienza Tu Proyecto Hoy
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16 border-b border-white/5 pb-12" data-id="element-63">
          <div className="col-span-1 md:col-span-2" data-id="element-64">
            <a href="#" className="flex items-center gap-3 mb-6" data-id="element-65">
              <img src={LOGO_COLOR} alt="Estrategias Digitales A-Z" className="h-14 w-auto object-contain drop-shadow-[0_0_10px_rgba(124,58,237,0.3)]" data-id="element-66" />
            </a>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-67">
              Transformando negocios con creatividad e inteligencia artificial.
              Creamos el futuro del marketing digital en Costa Rica.
            </p>
            <div className="flex gap-4" data-id="element-68">
              {[Instagram, Facebook, Linkedin, Mail].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-purple-600 hover:text-white transition-all duration-300" data-id="element-69">
                  <Icon className="w-5 h-5" data-id="element-70" />
                </a>)}
            </div>
          </div>

          <div data-id="element-71">
            <h4 className="text-white font-bold mb-6 font-orbitron" data-id="element-72">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-4" data-id="element-73">
              {['Beneficios', 'Método', 'Testimonios', 'Precios', 'FAQ'].map(item => <li key={item} data-id="element-74">
                    <a href={`#${item.toLowerCase()}`} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-75">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          <div data-id="element-76">
            <h4 className="text-white font-bold mb-6 font-orbitron" data-id="element-77">
              Contacto
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-78">
              <li data-id="element-79">San José, Costa Rica 🇨🇷</li>
              <li data-id="element-80">
                <a href="mailto:holaestrategiasdigitalesaz@gmail.com" className="group block w-full max-w-[220px] overflow-hidden rounded-lg bg-white/5 border border-white/10 hover:border-purple-500/40 hover:bg-white/10 transition-all duration-300 cursor-pointer" data-id="element-81">
                  <div className="flex items-center gap-2 px-3 py-2" data-id="element-82">
                    <Mail className="w-4 h-4 text-purple-400 flex-shrink-0" data-id="element-83" />
                    <div className="overflow-hidden flex-1" data-id="element-84">
                      <div className="animate-marquee whitespace-nowrap text-sm text-gray-300 group-hover:text-purple-300 transition-colors" data-id="element-85">
                        holaestrategiasdigitalesaz@gmail.com&nbsp;&nbsp;&nbsp;✦&nbsp;&nbsp;&nbsp;holaestrategiasdigitalesaz@gmail.com&nbsp;&nbsp;&nbsp;✦&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </a>
              </li>
              <li data-id="element-86">+506 8531-6690</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-87">
          <p data-id="element-88">
            © 2026 Estrategias Digitales A-Z. Todos los derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-89">
            <a href="#" className="hover:text-white transition-colors" data-id="element-90">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-91">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}